import * as React from "react";
import Box from "@mui/material/Box";

/**
 * MangoMap logo component for use in onboarding stories.
 * Uses the actual logo asset to match production appearance.
 */
export const MangoLogo = (): React.JSX.Element => (
	<Box
		component="img"
		src="/app-assets/mango-logo-dark.svg"
		alt="MangoMap"
		sx={{ height: 32, width: "auto" }}
	/>
);
